<script context="module" lang="ts">
  export var id = 0;
  export const getId = (name: string) => {
    id += 1;
    return `${name} ${id}`;
  };

  export const defaultSettings: TDividingHeaderSettings = {
    title: "Divider",
  };
</script>

<script lang="ts">
  import type { TDividingHeaderProps, TDividingHeaderSettings } from "./types";

  interface $$Props extends TDividingHeaderProps {}

  export let id: string;
  export let settings: Partial<TDividingHeaderSettings> = {};

  const _settings = {
    ...defaultSettings,
    ...settings,
  };
</script>

<div>
  <hr />
  <p
    data-pw-namespace={id ? `Dividing Header ${id}` : "Dividing Header"}
    class="dividing-header"
  >
    {_settings.title}
  </p>
  <hr />
</div>

<style>
  p {
    margin: 0px 20px;
  }

  div {
    position: relative;
    width: calc(100% + var(--sw-container-padding) * 2) !important;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    width: 100%;
    margin: calc(var(--sw-container-padding)) 0px;
    opacity: 0.5;
  }

  hr {
    justify-self: stretch;
    flex: 1;
    opacity: 0.2;
  }
</style>
